import { AxiosInstance } from 'axios';
import { CreateTaskDeliverablePackRequestInput, CurrentTaskDeliverablePackFilterInput } from './inputs';
import { TaskDeliverablePackRequestRef } from './refs';
import { TaskDeliverablePackResource } from './resources';
import qs from 'qs';

export default class TaskDeliverablePack {
    private basePath = '/api/task-deliverable-pack';
    private http;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Fetches current task deliverable pack for task
    getCurrent = async (filter: CurrentTaskDeliverablePackFilterInput): Promise<TaskDeliverablePackResource> => {
        const query = qs.stringify({ ...filter });
        const { data } = await this.http.get(`${this.basePath}/current?${query}`);
        return data;
    };

    // Create new request to generate task deliverable pack
    createRequest = async (input: CreateTaskDeliverablePackRequestInput): Promise<TaskDeliverablePackRequestRef> => {
        const { data } = await this.http.post(`${this.basePath}/request`, input);

        return data;
    };

}
